import { render } from "./SlimlineSizeForm.vue?vue&type=template&id=ffd8dd68&scoped=true"
import script from "./SlimlineSizeForm.vue?vue&type=script&lang=js"
export * from "./SlimlineSizeForm.vue?vue&type=script&lang=js"

import "./SlimlineSizeForm.vue?vue&type=style&index=0&id=ffd8dd68&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffd8dd68"]])

export default __exports__